<template>
  <div class="content_main">
    <div class="content_main_top">
       <a-tree-select allowClear  placeholder="请选择省/市/区" class="a_input_self margin_self" 
              :treeData="LocationList"  v-model="queryParam.pid" show-search tree-node-filter-prop="title">
			  	</a-tree-select>
      <!-- <a-select placeholder="请选择层级" class="a_input_self margin_self" v-model="queryParam.deep" @keyup.enter.native="$refs.table.refresh(true)">
        <a-select-option :value="''">所有</a-select-option>
        <a-select-option v-for="(d, index) in deeps" :key="index" :value="d.value">{{ d.label }}</a-select-option>
      </a-select> -->
      <!-- <a-input placeholder="请输入名称" class="a_input_self margin_self" v-model="queryParam.name" @keyup.enter.native="$refs.table.refresh(true)"/>
      <a-input placeholder="请输入上级编号" class="a_input_self margin_self" v-model="queryParam.pid" @keyup.enter.native="$refs.table.refresh(true)" /> -->
      <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增地区</a-button>
      <!-- <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0"> -->
        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">批量删除</a-button>
      <!-- </a-dropdown> -->
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <s-table
        size="default"
        ref="table"
        rowKey="id"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data="loadData"
        defaultSort="createTime"
        :scroll="{  y: scroll_y }"
        :expandIconAsCell='false'
        :expandIconColumnIndex=-1 
      >
        <span slot="deep" slot-scope="text">
          {{ text | deepFilter }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="removeEnable" @click="delByIds(record.id)">删除</a>
        </span>
      </s-table>
    </div>

    <dist-modal ref="modal" @ok="handleOk" :deeps="deeps" @refresh="change1()"/>
  </div>
</template>

<script>
import { districts } from '@/api/Industry'
import { STable } from '@/components'
import { getDistList, delDist, districtsDelete } from '@/api/system'
import DistModal from './modules/DistModal.vue'
import { checkPermission } from '@/utils/permissions'
const deepMap = {}

export default {
  name: 'TableList',
  components: {
    STable,
    DistModal,
  },
  data() {
    return {
      LocationList: [],
      scroll_y:150,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '层级',
          dataIndex: 'deep',
          scopedSlots: { customRender: 'deep' },
        },
        {
          title: '上级名称',
          dataIndex: 'pname',
        },
        {
          title: '简称',
          dataIndex: 'name',
        },
        // {
        //   title: '拼音',
        //   dataIndex: 'pinyin',
        // },
        // {
        //   title: '拼音缩写',
        //   dataIndex: 'pinyinShor',
        // },
        {
          title: '全称',
          dataIndex: 'extName',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          sorter: true,
        },
        {
          title: '操作人',
          dataIndex: 'operator',
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getDistList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
      deeps: [
        { value: 0, label: '省' },
        { value: 1, label: '市' },
        { value: 2, label: '区/县' },
      ],
      addEnable: checkPermission('system:districts:add'),
      editEnabel: checkPermission('system:districts:edit'),
      removeEnable: checkPermission('system:districts:remove'),
    }
  },
  filters: {
    deepFilter(type) {
      return deepMap[type].text
    },
  },
  created() {
    this.getData()
    this.deeps.map((d) => {
      deepMap[d.value] = { text: d.label }
    })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
        this.$forceUpdate()
      }, 1000)
    })
  },
  methods: {
     //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
    change1() {
      this.$refs.table.refresh(true)
      this.getData()
      console.log('22222222222222222222222222222222222222222')

    },
    getData() {
          districts().then((res) => {
      // console.log(this.$store.getters, 'this.$store.getters===================================')
      console.log(res.data.tree, 'res.data.tree=========================')
      // this.LocationList = res.data.tree
       this.visible = true
        const list = res.data.tree
        list.forEach( item => {
          item.value = item.id
          item.title = item.extName
          if(item.children.length >= 0 ) {
             item.children.forEach( item1 => {
                item1.value = item1.id
                item1.title = item1.extName
                if(item1.children.length >= 0) {
                  delete item1['children']
                }
             })
           
          }


        })   
        this.LocationList = list 
        console.log(list , 'list ==========================')
    })

    },
    onSelectChange(selectedRowKeys) {
      console.log(selectedRowKeys, 'selectedRowKeys=========================')
      this.selectedRowKeys = selectedRowKeys
    },
    handleAdd(parentId) {
      this.$refs.modal.add(parentId)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },
    dataModal(dictType) {
      this.$refs.datamodal.show(dictType)
    },
    delByIds(ids) {
      // delDist
            var _this = this
            this.$confirm({
                title: '是否确认删除?',
                onOk() {
                     districtsDelete(ids).then((res) => {
                        if (res.code === 200) {
                        _this.$message.success(`删除成功`)
                        _this.handleOk()
                          } else {
                        _this.$message.error(res.msg)
                          }
                        _this.selectedRowKeys = []
                        })
                
                },
                onCancel() {
                    _this.$message.warning('你点击了取消')
                },
                // class: 'test',
            })
     
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
